import { Injectable } from "@angular/core";
import { UiArguments } from "@recore-solutions/nstar-lib";
import { CodeTableService } from "src/app/listing/code-table.service";
import { ListingService } from "./listing.service";
import { LoonFnFactoriesService } from "./loon-fn-factories.service";

@Injectable({ providedIn: "root" })
export class PostalCityFnFactoriesService extends LoonFnFactoriesService {
	constructor(
		protected listingService: ListingService,
		protected codeTableService?: CodeTableService
	) {
		super(listingService, codeTableService);
	}
	resultTransformFn = (uiArguments: UiArguments) => {
		const parent = this.getParentFromUiArguments(uiArguments);
		if (parent.longName === "Postal City") {
			return (results: any[]) => results.filter((c) => ["B", "P"].includes(c.cityTypeFLG));
		}
		return (results: any[]) => results;
	};
}
